import React, { useState,useEffect } from 'react'
import { Button, DatePicker, Input, Select, Table } from "antd";
import "aos/dist/aos.css";
import "../MainCSS.css";
import { Option } from "antd/es/mentions";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { GetRackRemark, SaveRackRemarkUpdates } from '../../AllAPI/ProductionAPI/ProductionApi';
import dayjs from 'dayjs';
const RackRemark = () =>  {

  const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {};
  // const storedUserData = sessionStorage.getItem('userData') || '';

 const commonHeaders = {
  headers: {
    // createdBy: storedUserData || '',
    // updatedBy: storedUserData || '',
    createdBy: 1,
    updatedBy: 2,
    userIp: storedHeaders.userIp || '',
    userLat: storedHeaders.userLat || '',
    userLong: storedHeaders.userLong || '',
    deviceSign: storedHeaders.deviceSign || '',
  },
};

const commonHeaders1 = {
  headers: {
    createdBy: 1,
    updatedBy: 2,
  },
}

    
    
      const [errors, setErrors] = useState({
        SelectDate: "",
      });
      const [perPage, setPerPage] = useState(10);
      const [pageSize, setPageSize] = useState(10);
      const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [totalEntries, setTotalEntries] = useState(0);
    
        const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY']

      const [SelectDate, setSelectDate] = useState(dayjs());
    
   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    
      const [saveButton, setSaveButton] = useState(true);
    
    
      //======Search data from table===============
      const handleSearch = (value) => {
        const searchValue = value.toLowerCase();
      
        const filtered = data.filter((item) =>
          Object.values(item).some((val) =>
            String(val ?? "").toLowerCase().includes(searchValue)
          )
        );
      
        setFilteredData(filtered);
        setTotalEntries(filtered.length);
        setCurrentPage(1);
      };
      //==========Pagination=======================
      const handlePageSizeChange = (value) => {
        setPageSize(value);
      };
    
   const [data, setData] = useState([]);

//      const columns = [
//   { name: 'Date', selector: row => row.rackDate, sortable: true },
//   { name: 'Rack NO.', selector: row => row.rackNumber, sortable: true },
//   { name: 'Item Name', selector: row => row.dieName, sortable: true },
//   { name: 'Length', selector: row => row.length, sortable: true },
//   { name: 'Wt Per Pcs', selector: row => row.wtPerPcs, sortable: true },
//   { name: 'Wt./R', selector: row => row.wtRange, sortable: true },
//   { name: 'Total Pcs', selector: row => row.totalPcs, sortable: true },
//   { name: 'Qty', selector: row => row.qty, sortable: true },
//   { name: 'Customer Name', selector: row => row.customerName, sortable: true },
//   { name: 'Pcs Per Bundle', selector: row => row.pcsPerBundle, sortable: true },

//   // // Input columns using Ant Design Input
//   // {
//   //   name: 'Remark 1',
//   //   cell: row => (
//   //     <Input.TextArea
//   //       value={row.remark1 || ''}
//   //       onChange={e => handleInputChange(e, row, 'remark1')}
//   //       autoSize
//   //     />
//   //   ),
//   //   ignoreRowClick: true,
//   //   allowOverflow: true,
//   //   button: true,
//   // },
//   // {
//   //   name: 'Remark 2',
//   //   cell: row => (
//   //     <Input.TextArea
//   //       value={row.remark2 || ''}
//   //       onChange={e => handleInputChange(e, row, 'remark2')}
//   //       autoSize
//   //     />
//   //   ),
//   //   ignoreRowClick: true,
//   //   allowOverflow: true,
//   //   button: true,
//   // },
//   // {
//   //   name: 'Hardness',
//   //   cell: row => (
//   //     <Input.TextArea
//   //       value={row.hardness || ''}
//   //       onChange={e => handleInputChange(e, row, 'hardness')}
//   //       autoSize
//   //     />
//   //   ),
//   //   ignoreRowClick: true,
//   //   allowOverflow: true,
//   //   button: true,
//   // },
//   // {
//   //   name: 'Finish',
//   //   cell: row => (
//   //     <Input.TextArea
//   //       value={row.finish || ''}
//   //       onChange={e => handleInputChange(e, row, 'finish')}
//   //       autoSize
//   //     />
//   //   ),
//   //   ignoreRowClick: true,
//   //   allowOverflow: true,
//   //   button: true,
//   // },
//   // {
//   //   name: 'Rejection',
//   //   cell: row => (
//   //     <Input.TextArea
//   //       value={row.rejection || ''}
//   //       onChange={e => handleInputChange(e, row, 'rejection')}
//   //       autoSize
//   //     />
//   //   ),
//   //   ignoreRowClick: true,
//   //   allowOverflow: true,
//   //   button: true,
//   // },
//   // {
//   //   name: 'Actions',
//   //   cell: row => (
//   //     <Button type="primary"  
//   //     onClick={() => handleSave(row)}
//   //     >
//   //       Save
//   //     </Button>
//   //   ),
//   //   ignoreRowClick: true,
//   //   allowOverflow: true,
//   //   button: true,
//   // },
// ];


const columns = [
  { 
    title: 'Date', 
    dataIndex: 'rackDate', 
    key: 'rackDate', 
    sorter: (a, b) => new Date(a.rackDate) - new Date(b.rackDate) ,
     render: (text) => {
    const date = new Date(text);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  },
  },
  { 
    title: 'Rack No.', 
    dataIndex: 'rackNumber', 
    key: 'rackNumber', 
    sorter: (a, b) => a.rackNumber.localeCompare(b.rackNumber)
  },
  { 
    title: 'Item Name', 
    dataIndex: 'dieName', 
    key: 'dieName', 
    sorter: (a, b) => a.dieName.localeCompare(b.dieName)
  },
  { 
    title: 'Length', 
    dataIndex: 'length', 
    key: 'length', 
    sorter: (a, b) => a.length - b.length
  },
  { 
    title: 'Wt Per Pcs', 
    dataIndex: 'wtPerPcs', 
    key: 'wtPerPcs', 
    sorter: (a, b) => a.wtPerPcs - b.wtPerPcs
  },
  { 
    title: 'Wt./R', 
    dataIndex: 'wtRange', 
    key: 'wtRange', 
    sorter: (a, b) => a.wtRange - b.wtRange
  },
  { 
    title: 'Total Pcs', 
    dataIndex: 'totalPcs', 
    key: 'totalPcs', 
    sorter: (a, b) => a.totalPcs - b.totalPcs
  },
  { 
    title: 'Qty', 
    dataIndex: 'qty', 
    key: 'qty', 
    sorter: (a, b) => a.qty - b.qty
  },
    { 
    title: 'Pending Order ID', 
    dataIndex: 'pendingOrderId', 
    key: 'pendingOrderId', 
    sorter: (a, b) => a.pendingOrderId.localeCompare(b.pendingOrderId)
  },
  { 
    title: 'Customer Name', 
    dataIndex: 'customerName', 
    key: 'customerName', 
    sorter: (a, b) => a.customerName.localeCompare(b.customerName)
  },
  { 
    title: 'Pcs Per Bundle', 
    dataIndex: 'pcsPerBundle', 
    key: 'pcsPerBundle', 
    sorter: (a, b) => a.pcsPerBundle - b.pcsPerBundle
  }
];



      const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023e7d",
            color: "#fff",
            padding: "10px",
            fontSize: "15px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
                  fontSize: '15px',

          }}
        >
          {children}
        </td>
      ),
    },
  };
  
     const handleInputChange = (e, row, field) => {
  const updatedData = filteredData.map(item =>
    item.id === row.id ? { ...item, [field]: e.target.value } : item
  );
  setFilteredData(updatedData);
};

const handleSave = async (row) => {
  const payload = {
    rackNumberId: row.rackNumberId,     // ensure this field exists in row
    pressOutputId: row.id,   // ensure this field exists in row
    remark1: row.remark1 || '',
    remark2: row.remark2 || '',
    hardness: row.hardness || '',
    finish: row.finish || '',
    rejection: row.rejection || ''
  };

  try {
    const response = await axios.post(
      SaveRackRemarkUpdates,
      payload,
      commonHeaders
    );

    if (response.status === 200) {
      toast.success('Rack Remark saved successfully.');
      handleSubmit();
      console.log('Saved Row:', row);
    } else {
      toast.error('Failed to save Rack Remark.');
    }
  } catch (error) {
    console.error('Save error:', error);
    toast.error('Error saving Rack Remark.');
  }
};

  

    //=========Submit to get Table data ============
    const handleSubmit = async () => {
        let isValid = true;
        const errorObj = {};
    
        // if (!SelectDate.trim()) {
        //   isValid = false;
        //   errorObj.SelectDate = "Designation Name is required *";
        // }
    
        setErrors(errorObj); // Set error messages
    
        if (!isValid) return;
    
        const saveData = {
            SelectDate: SelectDate,
          };       
        
       try {
             const response = await axios.get(`${GetRackRemark}?date=${dayjs(SelectDate).format("YYYY-MM-DD")}`,commonHeaders);
       const remarkDetails = response.data
      
            if (!remarkDetails) {
              toast.error('Failed to fetch order details.')
              return
            }
      
          if (Array.isArray(remarkDetails) && remarkDetails.length > 0) {
          
                 setData(response.data);
               setFilteredData(response.data); // Set initial filtered data as the fetched data
               setTotalEntries(response.data.length); // Set the total number of entries
          
     
            }else {
                    toast.warn('No items found for the selected order.')
                    setData([]) // Clear order items
                    setFilteredData([]) // Clear filtered data (this will reset the table display)
                    setTotalEntries(0) // Reset total entries count
                  }
          } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Error occurred while submitting data");
          }
    };
    
   

   

  return (
     <>
       <div className="px-5 py-3" style={{ fontSize: "15px" }}>
          <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
              <div className="col-12">
        
                  <div className="row px-md-5 mt-3 p-2">
                        <div className="row p-0 m-0">
            
                          <div className="col-12 col-lg-4"></div>

                          <div className="col-12 col-lg-4 py-1">
                                <label className="labels">Select Date</label>
                               <DatePicker
                                       value={SelectDate}
                                       onChange={(value) => setSelectDate(value)}
                                       placeholder="Select Date"
                                       format={dateFormatList}
                                       style={{ width: '100%' }}
                                       
                                     />
                                {errors.SelectDate && (
                                  <div className="errorField">{errors.SelectDate}</div>
                                )}
                          </div>

                          <div className="col-12 col-lg-4"></div>
            
                        </div>   
            
                        <div className="col-12 text-center pt-3">
                         
                            {saveButton && (
                            <Button
                              type="submit"
                              className="SubmitBtn mx-1"
                              onClick={handleSubmit}
                            >
                              Show
                            </Button>
                            )}
                       
                        </div>
            
                        <div  className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid rgb(207, 207, 207)" }}></div>
                  </div>
            
                  {/*================ Table =========================*/}
                  <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
                    <div
                      className="col-12 py-3 shadow border"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="col-12 px-md-5"
                        style={{ display: "flex", justifyContent: "space-between" }}
                      >
                        <div>
                          <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                          <Select
                            defaultValue={pageSize}
                            onChange={handlePageSizeChange}
                            style={{ width: 120, textAlign: "center" }}
                          >
                            <Option value={10}>10</Option>
                            <Option value={20}>20</Option>
                            <Option value={30}>30</Option>
                          </Select>
                            {/* <div style={{ marginBottom: 10 }}>
        Show{' '}
        <select
          value={perPage}
           onChange={(e) => {
    setPerPage(Number(e.target.value));
    setResetPaginationToggle(prev => !prev); // Trigger reset
  }}
        >
          {[ 10, 20,30, 50, 100].map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>{' '}
        entries
      </div> */}
                        </div>
            
                        <div className="pt-4 pt-md-0">
                          <Input.Search
                            placeholder="Search"
                            onChange={(e) => handleSearch(e.target.value)}
                            style={{ width: 200, marginBottom: 16 }}
                          />
                        </div>
                      </div>
            
                      <div style={{ backgroundColor: "white" }}>
                     {/* <DataTable
        columns={columns}
        data={filteredData}
        pagination
 paginationPerPage={perPage}   
      paginationRowsPerPageOptions={[ 10,  20, 30,50, 100]}
        highlightOnHover
        striped
        responsive
        
   customStyles={{
    headCells: {
    style: {
      backgroundColor: '#023e7d',
      color: '#fff',
      padding: '10px',
      fontSize: '15px',
      borderRadius: '0px',
    },
  },
  rows: {
    style: {
      backgroundColor: '#f0f7fd',
      minHeight: '48px', // optional
    },
  },
  cells: {
    style: {
      padding: '8px',
            fontSize: '15px',

    },
  },
  }}
      /> */}
       <Table
                            bordered
                            style={{ padding: "0px 20px", overflowX: "auto" }}
                            columns={columns}
                            dataSource={filteredData}
                            pagination={{
                              pageSize: pageSize,
                              total: totalEntries,
                              showTotal: (total, range) =>
                                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                              current: currentPage,
                              onChange: (page) => setCurrentPage(page),
                            }}
                            showSorterTooltip={false}
                            rowKey={(record) => record.id}
                            components={components}
                          />
                      </div>
                    </div>
                  </div>
              </div>
           
          </div>
        </div>
       </>
  )
}


export default RackRemark